/* This file was generated automatically. Do not edit manually. */

import { createGxGuestAiSmartTipsRepository as gxGuestAiSmartTips } from './gxGuestAiSmartTips';

export * from './types';

export const gxGuestAiApiBasePath = '/api/atlas/v1/gxGuestAi';

export const gxGuestAiRestRepositoryFactories = {
    gxGuestAiSmartTips,
};
